export default __webpack_public_path__ + "c198347ad8edfd05bc66c57af7e62451.svg";